if (!customElements.get('sticky-atc-bar')) {
  customElements.define('sticky-atc-bar', class StickyAtcBar extends HTMLElement {
    constructor() {
      super();
      this.submitBtn = this.querySelector('[data-sticky-submit]');
      this.priceEl = this.querySelector('[data-sticky-price]');
      this.isMainSubmitVisible = true;
      this.minimumScrollOffset = 180;
      this.onScroll = this.handleScroll.bind(this);
      this.onResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      if (!this.submitBtn) return;

      document.body.classList.add('has-sticky-atc');

      this.updateReservedSpace();

      // Watch the main product submit button
      var mainSubmit = document.querySelector('.product-form__submit');
      if (mainSubmit) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            this.isMainSubmitVisible = entry.isIntersecting;
            this.updateVisibility();
          });
        }, { threshold: 0 });

        this.observer.observe(mainSubmit);
      } else {
        this.isMainSubmitVisible = false;
      }

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);
      this.handleResize();
      this.updateVisibility();

      // Click triggers main form submit
      this.submitBtn.addEventListener('click', () => {
        var mainForm = document.querySelector('product-form form');
        if (mainForm) {
          mainForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      });

      // Listen for variant changes
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (!event.data || !event.data.variant) return;
          var variant = event.data.variant;
          if (this.priceEl && variant.price != null) {
            if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
              this.priceEl.textContent = Shopify.formatMoney(variant.price);
            } else {
              this.priceEl.textContent = (variant.price / 100).toLocaleString('en-US', { style: 'currency', currency: window.Shopify && Shopify.currency && Shopify.currency.active || 'USD' });
            }
          }
          if (variant.available) {
            this.submitBtn.removeAttribute('disabled');
            this.submitBtn.textContent = window.variantStrings ? window.variantStrings.addToCart : 'Add to Cart';
          } else {
            this.submitBtn.setAttribute('disabled', '');
            this.submitBtn.textContent = window.variantStrings ? window.variantStrings.soldOut : 'Sold Out';
          }
        });
      }
    }

    handleScroll() {
      this.updateVisibility();
    }

    handleResize() {
      this.minimumScrollOffset = Math.min(300, Math.round(window.innerHeight * 0.35));
      this.updateReservedSpace();
      this.updateVisibility();
    }

    updateReservedSpace() {
      const barHeight = Math.ceil(this.offsetHeight || 0);
      if (barHeight > 0) {
        document.documentElement.style.setProperty('--sticky-atc-height', `${barHeight}px`);
      }
    }

    updateVisibility() {
      const passedScrollGate = window.scrollY > this.minimumScrollOffset;
      const shouldShow = passedScrollGate && !this.isMainSubmitVisible;
      this.classList.toggle('is-visible', shouldShow);
      document.body.classList.toggle('has-sticky-atc-visible', shouldShow);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      document.body.classList.remove('has-sticky-atc');
      document.body.classList.remove('has-sticky-atc-visible');
      document.documentElement.style.removeProperty('--sticky-atc-height');
    }
  });
}
